import { useEffect, useState } from "react";
import axios from "axios";
import { Grid, CircularProgress, Alert } from "@mui/material";
import PageProtectedOnboarding from "../../../components/Page/PageProtectedOnboarding";
import * as c from "../../../constants";
import { pool } from "../../../constants";
import { useAuth } from "../../../provider";
import { useTranslation } from "../../../language";
import OnbSteps from "../../../components/Steps/OnbSteps";
import QuestionnaireForm from "./QuestionnaireForm";

export default function NewQuestionnaire() {
  const { state } = useAuth();
  const { t, changeLanguage } = useTranslation();

  const [hasMicrobiome, setHasMicrobiome] = useState(null);
  const [visitLoading, setVisitLoading] = useState(true);
  const [visitError, setVisitError] = useState(null);

  useEffect(() => {
    if (state.user?.language) {
      changeLanguage(state.user.language);
    }
  }, [state.user?.language]);

  useEffect(() => {
    if (!state?.user?.id) return;

    axios
      .get(`${c.API_URL}/api/current-lab-visit/`)
      .then((res) => {
        setHasMicrobiome(Boolean(res.data?.has_microbiome));
        setVisitLoading(false);
      })
      .catch(() => {
        setVisitError(t("onb_quest_err_no_visit"));
        setVisitLoading(false);
      });
  }, [state?.user?.id]);

  return (
    <PageProtectedOnboarding
      headerImage={pool}
      brandtext={t("onbsub_brandtext")}
      content={
        <Grid container sx={{ mb: 5, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Grid size={12} sx={{ width: '100%', maxWidth: 900, px: { xs: 1, sm: 2 }, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <OnbSteps stepNumber={2} />
          </Grid>

          <Grid size={12} sx={{ width: '100%', maxWidth: 900, px: { xs: 1, sm: 2 }, mt: 6 }}>
            {visitLoading ? (
              <Grid container justifyContent="center">
                <CircularProgress />
              </Grid>
            ) : visitError ? (
              <Grid container justifyContent="center">
                <Alert severity="error">{visitError}</Alert>
              </Grid>
            ) : (
              <QuestionnaireForm kind={hasMicrobiome ? "bioma" : "speak"} />
            )}
          </Grid>
        </Grid>
      }
    />
  );
}
